import Vue from "vue";
import Router from "vue-router";

import Home from "./../pages/Home/Home";
import Course from "./../pages/Course/Course";
import OpenClass from "./../pages/OpenClass/OpenClass";
import Exercise from "./../pages/Exercise/Exercise";
import ListenList from "./../pages/Listenlist/Listenlist";
import Listen from "./../pages/Listen/Listen";
import Scripture from "./../pages/Scripture/Scripture";
import ExerciseList from "./../pages/ExerciseList/ExerciseList";
import Answer from "../pages/Answer/Answer";
import Login from "../pages/Login/Login";
import Curriculum from "../pages/Curriculum/Curriculum";
import CurriculumDetail from "../pages/Curriculum/Curriculum-detail";
import { addCookie} from "./../api/cookie";

import Campuses from "../pages/campuses/campuses";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      component: Home,
      name: "home",
      meta: { title: "羊驼雅思官网-雅思培训班-雅思报名" },
    },
    {
      path: "/campuses/:id",
      component: Campuses,
      name: "campuses",
    },
    {
      path: "/exerciselist",
      component: ExerciseList,
      name: "exerciselist",
      meta: {
        title: "雅思机考_雅思剑桥_雅思模考_雅思真题 - 羊驼雅思官网",
        description: "",
      },
    },
    {
      path: "/course",
      component: Course,
      meta: {
        title: "雅思课程_雅思培训课程_雅思在线课程_雅思公开课 - 羊驼雅思官网",
      },
    },
    {
      path: "/Curriculum",
      component: Curriculum,
      meta: {
        title: "雅思课程_雅思培训课程_雅思在线课程_雅思公开课 - 羊驼雅思官网",
      },
    },
    {
      path: "/curriculum-detail",
      component: CurriculumDetail,
      meta: { title: "羊驼雅思_雅思课程" },
    },
    {
      path: "/openclass",
      component: OpenClass,
      meta: { title: "羊驼雅思_免费公开课" },
    },
    {
      path: "/exercise/:camNum/:testNum/:sectionNum/",
      name: "exercise",
      component: Exercise,
      meta: { title: "雅思机考" },
    },
    {
      path: "/listen/:id/:camNum/:testNum/:sectionNum",
      // path:'/listen',
      name: "listen",
      component: Listen,
      meta: { title: "雅思听力_雅思听力练习_雅思听力题 - 羊驼雅思官网" },
    },
    {
      path: "/scripture",
      component: Scripture,
      name: "scripture",
      meta: { title: "雅思机经_雅思听力机经_雅思阅读机经 - 羊驼雅思官网" },
    },
    {
      path: "/answer/:camNum/:testNum",
      component: Answer,
      name: "answer",
      meta: { title: "雅思机考" },
    },
    {
      path: "/listenlist",
      component: ListenList,
      name: "listenlist",
      meta: { title: "雅思听力_雅思听力练习_雅思听力题 - 羊驼雅思官网" },
    },
    {
      path: "/login/:userCode",
      component: Login,
      name: "login",
      meta: { title: "羊驼雅思_登录" },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});
router.beforeEach(async (to, from, next) => { 
  if (to.query.token) {  
    window.localStorage.setItem("token", to.query.token);
    window.localStorage.setItem("expireIn", to.query.expireIn);
    addCookie("token", to.query.token, 30);
    window.location.href = to.path; 
  }
  if (to.meta.title) {
    //如果设置标题，拦截后设置标题
    document.title = to.meta.title;
  }
  // if(to.meta.description){
  //   document.querySelector("meta[name='description']").content=to.meta.description;
  // }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js